
import styles from '../coverSection/coverSection.module.css';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';

export function CoverSection() {
  return (
    <section className={styles.coverContainer}>
      <MarkupLayout>
        <div className={styles.coverTextContainer}>
          <h2 className={styles.coverHeader}>
            <span>автомобильные</span>
            <span style={{ display: 'block' }}>фильтры</span>
          </h2>
          <p className={styles.coverParagraph}>
            Всё, что нужно знать <br /> о фильтрации
          </p>
        </div>
      </MarkupLayout>
    </section>
  );
}
